import React, { FC, ReactNode, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import ActivityFrame from "../../../components/activity-frame/activity-frame";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import Tabs, { getTabsListFromLabels } from "../../../components/tabs/tabs";
import TourRoutesTab from "../../../containers/tour-routes-tab";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { Category } from "../../../models/Category";
import { getTourRoutes } from "../../../services/tourRouteService";
import { showError } from "../../../services/utilities/ServiceError";

const ScheduledTours: FC = () => {
    const [selected, setSelected] = useState(0);
    const [busy, setBusy] = useState(false);
    const history = useHistory();
    const [categories, setCategories] = useState<Category[]>([]);
    const [tabContent, setTabContent] = useState<ReactNode[]>([]);
    const { translate } = useLocale();

    useEffect(() => {
        getCategories();
    }, []);

    useEffect(() => {
        if (categories.length > 0) {
            const newTabContent = [getPlaceholderContent(), <TourRoutesTab />, getPlaceholderContent()];
            setTabContent(newTabContent);
        }
    }, [categories]);

    const getPlaceholderContent = () => {
        return <div style={{ marginLeft: "20px", marginTop: "20px" }}>This page is not available yet</div>
    }

    const getCategories = async () => {
        try {
            const tourRoutes = await getTourRoutes();

            setCategories([
                {
                    displayName: translate.byKey(TranslationKeys.activeTours),
                    heading: translate.byKey(TranslationKeys.activeTours),
                    value: "",
                    id: 0,
                    count: undefined,
                },
                {
                    displayName: translate.byKey(TranslationKeys.routes),
                    heading: translate.byKey(TranslationKeys.routes),
                    value: "",
                    id: 1,
                    count: tourRoutes.pagination.totalCount,
                },
                {
                    displayName: translate.byKey(TranslationKeys.notifications),
                    heading: translate.byKey(TranslationKeys.notifications),
                    value: "",
                    id: 2,
                    count: undefined,
                },

            ]);

            setBusy(false);
        } catch (error) {
            showError(error, toast.warn);
        }
    }

    return (
        <>
            <ActivityFrame busy={busy} className="flex flex-grow">
                <div className="pt-4 pl-4 pb-4 flex flex-col flex-grow ">
                    <Breadcrumb
                        path={[
                            {
                                value: "/access-control/modules",
                                displayName: translate.byKey(TranslationKeys.modules),
                            },
                            {
                                value: "/access-control/modules/scheduled-tours",
                                displayName: translate.byKey(TranslationKeys.scheduledTours),
                            }
                        ]}
                        onClick={(item) => history.push(item.value)}>
                    </Breadcrumb>
                    <Tabs
                        className="bg-white"
                        tabs={getTabsListFromLabels(categories)}
                        onSelect={(i) => setSelected(i)}
                        setSelectedTab={setSelected}
                        selected={selected}
                        onAdd={() => { }}
                        add={false}>
                        <div className="w-full flex flex-col">
                            {tabContent[selected]}
                        </div>
                    </Tabs>
                </div>
            </ActivityFrame>
        </>
    );
};

export default ScheduledTours;
